import { render, staticRenderFns } from "./scroller.global.vue?vue&type=template&id=920c841a&"
import script from "./scroller.global.vue?vue&type=script&lang=js&"
export * from "./scroller.global.vue?vue&type=script&lang=js&"
import style0 from "./scroller.global.vue?vue&type=style&index=0&id=920c841a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports